var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14132 10.4431C6.05137 10.4431 5.96141 10.4087 5.89276 10.3401L3.17526 7.62255C3.03794 7.48523 3.03794 7.26274 3.17526 7.12542C3.31258 6.9881 3.53507 6.9881 3.67239 7.12542L6.14134 9.59437L11.328 4.40768C11.4653 4.27036 11.6878 4.27036 11.8251 4.40768C11.9625 4.545 11.9625 4.76749 11.8251 4.90481L6.3899 10.3401C6.32122 10.4087 6.23127 10.4431 6.14132 10.4431Z",
    fill: "#138a39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.7c08187934f755418d2b20f2ea8ff64d.svg";
export { ForwardRef as ReactComponent };